import { Confirm } from "./types";

const defaultState = {
    isOpen: false,
    options: {},
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case Confirm.OPEN:
            return {
                ...state,
                isOpen: true,
                options: {
                    ...defaultState.options,
                    ...action.options,
                },
            };

        case Confirm.CLOSE:
            return {
                ...state,
                isOpen: false,
                options: {},
            };

        default:
            return state;
    }
};
